module.exports = {
  beginsWith: 'begins_with',
  between: 'between'
};